// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1-1if","content":"ManualTimeModal_content__1nVlT"};